Ext.define('SA.lq.Controller', {
    constructor({model, customLocationListener, locationAliasListener, controllers}) {
        this.model = model;
        this.customLocationListener = customLocationListener;
        this.locationAliasListener = locationAliasListener;
        this.controllers = controllers;

        this.activeController = null;
    },

    activate() {
        SA.HistoricalModeIndicator.maybeShow(this.model);
        SA.PageHeader.setView(this.model);
        SA.ViewChooser.setView(this.model);

        this.customLocationListener.listen();
    },

    deactivate() {
        this.customLocationListener.unlisten();
    },

    getModel() {
        return this.model;
    },

    isViewMode() {
        return this.activeController === this.controllers.view;
    },

    onCustomLocationChange() {
        if (this.isViewMode() && !this.model.isViewable()) {
            SA.AppController.showProjectView(this.model, 'edit');
            return;
        }

        this.activeController.refreshContent();
    },

    onLocationAliasChange(aliasChange) {
        this.controllers.edit.refreshContent();
        this.controllers.view.onLocationAliasChange(aliasChange);
    },

    setModeActive(mode, active) {
        if (active) {
            this.activeController = this.controllers[mode];
            this.activeController.onActive();
            return;
        }

        this.activeController = null;
    }
});